import ClientNotificationInterface from '../../interfaces/client/Notification'

import getLabels from '../../utils/getLabels'

export default (notification?: ClientNotificationInterface) =>
  notification ? getLabels(notification.code) : ''
